import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TimeHighlight from './components/TimeHighlight';
import QuickContact from './components/QuickContact';
import Testimonials from './components/Testimonials';
import ServiceAreaMap from './components/ServiceAreaMap';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (id: string) => {
    setMenuOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white/95'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <i className="ri-truck-line text-2xl md:text-3xl text-yellow-500"></i>
            <span className="text-lg md:text-2xl font-bold text-black">Guincho Express</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#servicos" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium">Serviços</a>
            <a href="#area" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium">Área de Atuação</a>
            <a href="#depoimentos" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium">Depoimentos</a>
            <a href="#contato" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium">Contato</a>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`text-2xl text-black ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {menuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 shadow-lg px-4 py-4 flex flex-col gap-4">
            <button onClick={() => handleNavClick('servicos')} className="text-left text-gray-700 font-medium py-2 border-b border-gray-100 cursor-pointer">Serviços</button>
            <button onClick={() => handleNavClick('area')} className="text-left text-gray-700 font-medium py-2 border-b border-gray-100 cursor-pointer">Área de Atuação</button>
            <button onClick={() => handleNavClick('depoimentos')} className="text-left text-gray-700 font-medium py-2 border-b border-gray-100 cursor-pointer">Depoimentos</button>
            <button onClick={() => handleNavClick('contato')} className="text-left text-gray-700 font-medium py-2 cursor-pointer">Contato</button>
          </div>
        )}
      </nav>

      {/* Main Content */}
      <main className="pt-16 md:pt-20">
        <Hero />
        <TimeHighlight />
        <QuickContact />
        <Testimonials />
        <ServiceAreaMap />
        <CallToAction />
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
